export default {
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: '/api',
    prod: '.'
  },

  //配置路由信息 格式
  routers: [{
    path: '*',
    name: 'login',
    component: () => import('@/views/login/login.vue')
  }]
}
